var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mark-box"},[_c('correctTheoryPaper',{attrs:{"logId":_vm.logId,"headData":_vm.headData,"answerData":_vm.answerData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }